// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"9a9b5ed7","496":"4e1bcb84","622":"86a53358"}[chunkId] + ".chunk.css";
};